import { NewsLetterSubscribeDoubleOptIn } from './data-contracts';
import { HttpClient, RequestParams, TraceDataType } from './http-client';

import { loggerCan } from '@/data/utils/loggerUtil';
import { logger } from '@/logging/logger';

export class NewsletterSubscriptionsConfirmation<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
	 * No description
	 *
	 * @tags Newsletter subscriptions confirmation
	 * @name NewsLetterSubscriptionSubscribeDoubleOptInDetail
	 * @summary Confirm the double optin subscription for the given user id and email id..
	 * @request GET:/store/{storeId}/news_letter_subscription/subscribe_double_opt_in
	 * @secure
	 * @response `200` `NewsLetterSubscribeDoubleOptIn` The requested completed successfully.
	 * @response `400` `void` Bad request. The request could not be understood by the server due to malformed syntax.
	 * @response `401` `void` Not authenticated. The user session is not valid.
	 * @response `403` `void` The user is not authorized to perform the specified request.
	 * @response `404` `void` The specified resource could not be found.
	 * @response `500` `void` Internal server error. For details, see the server log files.
	 */
	newsLetterSubscriptionSubscribeDoubleOptInDetail = (
		storeId: string,
		query?: {
			/** The e-mail address to be added for news letter subscription. */
			emailId?: string;
			/** The language ID. */
			langId?: string;
			/** The contactListId. */
			contactListId?: string;
			/** flag to notify the request is from Ruby store. */
			x_rubyStore?: boolean;
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (
			loggerCan('trace') &&
			(!this.http.traceDetails ||
				this.http.traceDetails['newsLetterSubscriptionSubscribeDoubleOptInDetail'])
		) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/store/${storeId}/news_letter_subscription/subscribe_double_opt_in`,
				params: _params,
				query: query,
				methodName: 'newsLetterSubscriptionSubscribeDoubleOptInDetail',
			};
			logger.trace(traceData);
		}
		return this.http.request<NewsLetterSubscribeDoubleOptIn, void>({
			path: `/store/${storeId}/news_letter_subscription/subscribe_double_opt_in`,
			method: 'GET',
			query: query,
			secure: true,
			format: params.format ?? 'json',
			storeId,
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
}
